
<template>
<!-- 选择合同 -->
    <div>
      
                <!-- :projectId="form.projectId" -->
                 <el-form ref="searchFormRef" :model="query" label-width="80px" size="small">
          <el-row :gutter="20">
             <el-col span="6">
              <el-form-item label="合同编号" prop="name">
                <el-input clearable  v-model="query.code" maxlength="50" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同名称" prop="name">
                <el-input clearable  v-model="query.name" maxlength="50" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同对象" prop="partnerId">
                <el-select
                clearable
                  v-model="query.partnerId"
                  placeholder="请选择合同对象"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in partnerList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同类型" prop="type">
                <el-select clearable v-model="query.type" placeholder="请选择合同类型" style="width: 100%">
                  <el-option
                    v-for="(item, index) in projectContractTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> 
             
            <el-col :span="12">
                <el-form-item label="签订日期">
                     <el-date-picker
                                  style="width: 100%"
                                  clearable
                                  v-model="query.timeRange"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  >
                              </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col span="12" style="text-align:right">
              <el-button type="primary" @click="search" size="small"> 搜索 </el-button>
              <el-button @click="searchClear" size="small"> 清空 </el-button>
            </el-col>
          </el-row>
        </el-form>
        <!-- <el-radio-group v-model="radio"> -->
        <avue-crud
            :option="option"
            :table-loading="loading"
            :data="contractList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="search"
            @refresh-change="search">
            
            <template slot="choice" slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" @change='radioChange()'> {{' '}}</el-radio>
            </template>
            <template slot="lifecycleIndex" slot-scope="scope">
            <el-tag>
              {{
                tool.getDictionaryValue(
                  lifeCycleList,
                  'dictValue',
                  'dictKey',
                  scope.row.lifecycleIndex
                )
              }}
            </el-tag>
          </template>
            <template slot="settledAmount" slot-scope="scope">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.settledAmount)   }}</span></div>
            </template>
            <template slot="unsettledAmount" slot-scope="scope">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.unsettledAmount)   }}</span></div>
            </template>
            <template slot="contractAmount" slot-scope="scope">
                 <div class="money"><span>{{tool.money_format_allowvoid(scope.row.contractAmount)  }}</span></div>
            </template>
        </avue-crud>
        <!-- </el-radio-group> -->
         <div class="btnArea" style="text-align:right" v-if="!showButton">
            <el-button type="primary" v-show="operateStatus!=3" @click="submitContract">提交</el-button>
            <el-button    @click="cancleOperate">取消</el-button>
         </div>
      
        
    </div>
</template>

<script>
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary';
import { getPartnerList } from '@/api/crmedical/contract/contract/contract';
import { getDeviceConstractList } from '@/api/crmedical/contract/choiceContract/index.js';
import {
  getDictData,
} from '@/api/crmedical/contract/contract/contract';
export default {
  props: ['projectId','showButton']
    
  ,
  data() {
    return {
      lifeCycleList:[],
      projectContractTypeList: [], //合同类型
      partnerList: [], //合同对象
      radio: '',
      contractList: [],
      option: {
        page: true,
        height:'auto',
        align: 'center',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border:true,
        column: [
          {
            label: '选择',
            prop: 'choice',
            slot: true,
          },
          {
            label: '合同编号',
            prop: 'code',
          },
          {
            label: '合同名称',
            prop: 'name',
          },
          {
            label: '合同类型',
            prop: 'type',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl:
              '/api/v4ward/projectDict/dictionary?code=project_contract_type&&projectId=' +
              this.projectId,
          },
          {
            label: '合同对象',
            prop: 'partnerName',
          },
          {
            label: '签订日期',
            prop: 'signTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '合同金额',
            prop: 'contractAmount',
             slot:true,
          },
           {
            label: '合同状态',
            prop: 'lifecycleIndex',
            slot: true,
          },
          {
            label: '已结算金额',
            prop: 'settledAmount',
            slot:true,
          },
          {
            label: '未结算金额',
            prop: 'unsettledAmount',
            slot:true,
          },
          // {
          //   label: '备注',
          //   prop: 'remark',
          // },
        ],
      },
      query: {
        type: '',
        partnerId: '',
        name: '',
        code:'',
        timeRange:[],
        signTimeStart:'',
        signTimeEnd:''
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      loading:false,
    };
  },
  created() {
    this.loadProjectLifeCycle()
    this.search()
    this.getContractType();
    console.log(this.projectId)
  },
  methods: {
    //加载合同状态(生命周期)
    loadProjectLifeCycle() {
      getDictData({ code: 'contract_lifecycle' }).then((res) => {
        this.lifeCycleList = res.data;
      });
    },
    cancleOperate(){
      this.$emit("cancleOperate")
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
     
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      
    },
    search() {
      this.radio = ''
      this.loading = true
      console.log(this.query)
      if(this.query.timeRange&&this.query.timeRange.length>0){
        this.query.signTimeStart   = this.dayjs(this.query.timeRange[0]).format('YYYY-MM-DD 00:00:00')
        this.query.signTimeEnd   = this.dayjs(this.query.timeRange[1]).format('YYYY-MM-DD 23:59:59') 
      }else{
        this.query.signTimeEnd = ''
        this.query.signTimeStart = ''
        this.query.timeRange = []
      }
      getDeviceConstractList({
        projectId: this.projectId,
        type: this.query.type,
        partnerId: this.query.partnerId,
        name: this.query.name,
        current:this.page.currentPage,
        size:this.page.pageSize,
        signTimeStart:this.query.signTimeStart,
        signTimeEnd:this.query.signTimeEnd,
        code:this.query.code
      }).then(({ data }) => {
        this.contractList = data.records;
        this.page.total = data.total;
        this.loading = false
      });
    },
    radioChange() {
      console.log(this.radio);
    },
    //提交
    submitContract() {
      this.$emit('getConstract', this.radio);
      
    },
    //提交V2
    submitContractV2() {
      return this.radio;
      
    },
    searchClear() {
     this.query =  {
        type: '',
        partnerId: '',
        name: '',
        code:'',
        timeRange:[],
        signTimeStart:'',
        signTimeEnd:''
      }
    },
    //获取合同类型
    getContractType() {
      Promise.all([
        getProjectDict({
          projectId: this.projectId,
          code: 'project_contract_type',
        }),
        getPartnerList({ id: this.projectId }),
      ]).then((res) => {
        this.projectContractTypeList = res[0].data;
        this.partnerList = res[1].data;
        this.onLoad();
      });
    },
    
  },
};
</script>

<style scoped>
.btnArea {
  widows: 100%;
  text-align: center;
  margin-top: 20px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
</style>
